// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160.05 83.25"
      height={64}
      {...props}
    >
      <circle fill="#fceb18" cx={84} cy={46.17} r={37.08} />
      <path d="M52.32 43.35a7.13 7.13 0 0 0-5.66-2.83 6.35 6.35 0 0 0-6.37 6.54 6.48 6.48 0 0 0 6.59 6.55 6.87 6.87 0 0 0 5.44-2.83Zm.13 11.82a9.07 9.07 0 0 1-6.12 2.18 10.23 10.23 0 0 1-5-1.31 10.61 10.61 0 0 1 .05-18.12 9.43 9.43 0 0 1 4.85-1.26 9.27 9.27 0 0 1 6.21 2.24v-1.81h3.89v19.85h-3.88ZM60.64 37.09h4.01v19.85h-4.01zM62.62 28.15a2.65 2.65 0 0 1 2.66 2.66 2.61 2.61 0 0 1-2.66 2.62A2.58 2.58 0 0 1 60 30.81a2.61 2.61 0 0 1 2.62-2.66M68.95 28.27h4.01v28.67h-4.01zM86.35 53.56a6.26 6.26 0 0 0 6.25-6.55 6.26 6.26 0 1 0-12.5 0 6.26 6.26 0 0 0 6.25 6.55m0-16.89a10.05 10.05 0 0 1 10.26 10.34 10.26 10.26 0 1 1-20.52 0 10.05 10.05 0 0 1 10.26-10.34M33.12 37.09v19.85h-4V43.35a7.55 7.55 0 0 0-5.57-2.83 5 5 0 0 0-3.84 1.73 5.61 5.61 0 0 0-1.14 4v10.69h-4v-14a7.89 7.89 0 0 0-5.7-2.49 4.84 4.84 0 0 0-3.75 1.75 5.61 5.61 0 0 0-1.14 4v10.74h-4V46.8c0-3.33.59-5.28 1.81-6.8a9 9 0 0 1 7.05-3.33 10 10 0 0 1 7.56 3.29 9 9 0 0 1 7-3.29 8.61 8.61 0 0 1 5.83 2.32v-1.9Z" />
      <path fill="#00eefc" d="m160.05 6.48-13.57 16.48L131.74 0l28.31 6.48z" />
    </svg>
  );
};

const MailoIcon = Icon;
export default MailoIcon;
